<template>
  <AppLayout :title="title">
    <div class="grid grid-cols-4 gap-x-6 space-y-0 lg:gap-x-12">
      <QueueStatus :loading="!queueStatus.default" title="Default Queue" :queue="queueStatus.default" />
      <QueueStatus :loading="!queueStatus.slow" title="Slow Queue" :queue="queueStatus.slow" />
      <QueueStatus :loading="!queueStatus.analytics" title="Analytics Queue" :queue="queueStatus.analytics" />
      <QueueStatus :loading="!queueStatus.failed" title="Failed Jobs" :queue="queueStatus.failed" />
    </div>

    <DataTable
      title="Content Added to User Collections"
      endpoint="dashboard/content-added-to-collections"
      class="mt-6 lg:mt-12"
    >
      <template v-slot:rows="rows">
        <DataTableRow v-for="row in rows" :key="row.id" :row="row">
          <DataTableColumn title="Content">
            <div class="flex items-center space-x-4">
              <BlockTypeIcon :type="row.content.block_type" />
              <router-link :to="{ name: 'content.edit', params: { id: row.content.id } }">{{
                row.content.title
              }}</router-link>
            </div>
          </DataTableColumn>
          <DataTableColumn title="Collection">
            <router-link :to="{ name: 'collections.view', params: { id: row.collection.id } }">{{
              row.collection.name
            }}</router-link>
          </DataTableColumn>
          <DataTableColumn title="Added" width="max">{{ row.added_at | datetime }}</DataTableColumn>
        </DataTableRow>
      </template>
    </DataTable>

    <DataTable title="New User Content" endpoint="dashboard/content-added-by-users">
      <template v-slot:rows="rows">
        <DataTableRow v-for="row in rows" :key="row.id" :row="row">
          <DataTableColumn title="Content" sortable="title">
            <div class="flex items-center space-x-4">
              <BlockTypeIcon :type="row.block_type" />
              <router-link :to="{ name: 'content.edit', params: { id: row.id } }">{{ row.title }}</router-link>
            </div>
          </DataTableColumn>
          <DataTableColumn title="User" sortable="title">
            <p>
              <router-link :to="{ name: 'users.view', params: { id: row.user.id } }">{{ row.user.name }}</router-link>
            </p>
            <p>
              <router-link :to="{ name: 'partners.view', params: { id: row.partner.id } }" class="text-supplement">{{
                row.partner.name
              }}</router-link>
            </p>
          </DataTableColumn>
          <DataTableColumn title="Added" width="max">{{ row.created_at | datetime }}</DataTableColumn>
        </DataTableRow>
      </template>
    </DataTable>

    <DataTable
      title="No Result Searches"
      subtitle="within the last month"
      endpoint="dashboard/searches-with-no-results"
    >
      <template v-slot:rows="rows">
        <DataTableRow v-for="row in rows" :key="row.id" :row="row">
          <DataTableColumn title="Search Term" sortable="term">{{ row.term }}</DataTableColumn>
          <DataTableColumn title="Filters" width="max">
            <Icon icon="filter" v-tooltip="row.filters" />
          </DataTableColumn>
          <DataTableColumn title="When" width="max">{{ row.created_at | datetime("medium") }}</DataTableColumn>
        </DataTableRow>
      </template>
    </DataTable>

    <DataTable title="No Destination Content" endpoint="dashboard/content-with-no-destination">
      <template v-slot:rows="rows">
        <DataTableRow v-for="row in rows" :key="row.id" :row="row">
          <DataTableColumn title="Title" sortable="title">
            <router-link :to="{ name: 'content.edit', params: { id: row.id } }">{{ row.title }}</router-link>
          </DataTableColumn>
          <DataTableColumn title="Added" width="max">{{ row.created_at | datetime }}</DataTableColumn>
          <DataTableColumn title="Updated" width="max">{{ row.updated_at | datetime }}</DataTableColumn>
        </DataTableRow>
      </template>
    </DataTable>
  </AppLayout>
</template>

<script>
import BlockTypeIcon from "@/components/BlockTypeIcon"
import QueueStatus from "../../components/QueueStatus.vue"

export default {
  components: {
    BlockTypeIcon,
    QueueStatus
  },
  metaInfo() {
    return { title: this.title, bodyAttrs: { class: "page-dashboard" } }
  },
  data: () => ({
    title: "Dashboard",
    queueStatus: null
  }),
  async created() {
    let response = await this.$api.get("dashboard/queue-status")
    this.queueStatus = response.data
  }
}
</script>

<style>
.page-dashboard {
  .card {
    &-active-users,
    &-new-users {
      .card-body-inner {
        @apply p-8;
      }
    }
  }
}
</style>
